




















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { default as QuestionVue } from "./question";
import { QuestionMultipleTextModel, Question, MultipleTextCell } from "survey-core";
import BaseVue from "./base";
import { getComponentName } from "./question";

@Component
export class MultipleTextItem extends BaseVue {
  @Prop()
  question: QuestionMultipleTextModel;
  @Prop()
  cell: MultipleTextCell;

  getModel() {
    return this.cell.item.editor;
  }
  public get item() {
    return this.cell.item;
  }
  getComponentName(question: Question) {
    return getComponentName(question);
  }
}
Vue.component("survey-multipletext-item", MultipleTextItem);
export default MultipleTextItem;
